import isMobile from "./is-mobile";

/**
 * Checks if browser is mobile and not stand-alone dedicated vr device.
 * @return {Boolean} True if mobile browser detected.
 */
AFRAME.utils.device.isMobile = isMobile;
